module.exports = __webpack_public_path__ + "img/17845_L.785724c0.png";